import {
  createSlice,
  createEntityAdapter,
  createSelector
} from '@reduxjs/toolkit'
import { api, providesList } from '../base'

const transformErrorResponse = (response, meta, arg) => response.error

export const INITIAL_LANGUAGES = [
  { name: 'Arabic', language: 'ar' },
  { name: 'Bengali', language: 'bn' },
  { name: 'Chinese (Simplified)', language: 'zh-CN' },
  { name: 'English', language: 'en' },
  { name: 'French', language: 'fr' },
  { name: 'German', language: 'de' },
  { name: 'Hindi', language: 'hi' },
  { name: 'Italian', language: 'it' },
  { name: 'Portuguese', language: 'pt' },
  { name: 'Russian', language: 'ru' },
  { name: 'Spanish', language: 'es' },
]

export const languagesApi = api
  .enhanceEndpoints({ addTagTypes: ['Language'] })
  .injectEndpoints({
    keepUnusedDataFor: 60 * 60 * 24, // 24 hours
    endpoints: (builder) => ({
      // list languages
      listLanguages: builder.query({
        query: () => ({
          url: '/api/languages',
          method: 'GET',
        }),
        transformResponse: (response, meta, arg) => {
          return response.languages.items
        },
        transformErrorResponse,
      }),
      //
    }),
  })

export const {
  useListLanguagesQuery,
} = languagesApi

